<template>
  <div class="h5Container">
    <div class="stepBar" style="position:fixed;z-index:999;background:#fff">
      <div class="stepSlider" :style="`left:0rem;width:${(stepIndex==2?5:stepIndex)*2.5}rem`"></div>
      <div :class="stepIndex>=0?'stepItem stepActive rightArrow':'stepItem'" @click="switchStep(0)">1.注册机构</div>
      <div :class="stepIndex>=1?'stepItem stepActive rightArrow':'stepItem'" @click="switchStep(1)">2.选择模板</div>
      <div :class="stepIndex>=2?'stepItem stepActive rightArrow':'stepItem'" @click="switchStep(2)">3.开通成功</div>
    </div>
    <div class="stepBar"></div>
    <div v-if='stepIndex==0'>
      <div class="banner">
        <img src="../../../static/image/8.png" alt="" style="width:7.5rem;height:3.6rem;">
      </div>
      <div class="inputBox">
        <div class="inputItem">
          <input v-model="form.name" type="text" placeholder="用户名" class="defaultInput">
        </div>
        <div class="inputItem">
          <input v-model="form.companyName" type="text" placeholder="公司名称" class="defaultInput">
        </div>
        <div class="inputItem">
          <input v-model="form.account" type="number" placeholder="手机号" class="defaultInput" style="width:86%;">
          <div class="getVerifyCode" v-if="codeBtnShow" @click="getCode">获取验证码</div>
          <div :key="count" class="getVerifyCode" v-else>{{count}} s</div>
        </div>
        <div class="inputItem">
          <input v-model="form.code" type="text" placeholder="验证码" class="defaultInput">
        </div>
      </div>
      <div class="nextStep" v-if="form.name&&form.companyName&&form.account&&form.code" @click="login">下一步</div>
      <div class="nextStep disabledBtn" v-else>下一步</div>
    </div>
    <div v-if="stepIndex==1" class="themeBox">
      <div class="themeItem" @mouseover="clickedTemp = index" @mouseleave="isOver=false" v-for="(item,index) in tempOptions" :key="index">
        <p>{{item.name}}</p>
        <img src="../../../static/image/defaultTheme.png" alt="" @click="useThisTemp(item.id)">
        <div class="cover" v-if="item.defaultTheme">
          <img src="../../../static/image/circleTick.png" alt="">
        </div>
      </div>
      <div class="nextStep disabledBtn" v-if="disableNextFlag">下一步</div>
      <div class="nextStep" @click="sucessNext" v-else>下一步</div>
    </div>
    <div v-if="stepIndex==2" class="successBox">
      <img src="../../../static/image/successCircleTick.png" alt="">
      <p>开通成功</p>
      <div class="nextStep" @click="toPreviewH5">前往预览H5网校</div>
    </div>
  </div>
</template>
<script>

export default {
  components: {
  },
  data () {
    return {
      clickedId: '',
      registerData: {},
      disableNextFlag: true,
      tempOptions: [{
        name: '默认模板',
        id: 13,
        defaultTheme: false
      }],
      dynimicClass: 'stepItem',
      codeBtnShow: true,
      count: "",
      timer: null,
      stepIndex: 0,
      form: {
        account: "",
        name: '',
        companyName: '',
        code: "",
        password: "",
      },
    }
  },
  watch: {
    stepIndex: function (newVal) {
      console.log(newVal, this.stepIndex)
      if (newVal == 1) {
        // this.getTempDictionary()
      }
    }
  },
  created () {
    if (this.$route.path === '/h5Register') {
      let deviceWidth = document.documentElement.clientWidth
      if (deviceWidth > 750) deviceWidth = 750
      document.documentElement.style.fontSize = deviceWidth / 7.5 + 'px'
      window.onresize = () => {
        let deviceWidth = document.documentElement.clientWidth
        if (deviceWidth > 750) deviceWidth = 750
        document.documentElement.style.fontSize = deviceWidth / 7.5 + 'px'
      }
    }
  },
  methods: {
    useThisTemp (id) {
      // this.api.schoolPage.updateAgentTemp({ templateId: id }).then(res => {
      //   this.getTempDictionary()
      //   this.clickedId = id
      //   if (res.success) {
      //     this.disableNextFlag = false
      //     this.$message.success("操作成功")
      //   }
      // })
      this.disableNextFlag = false
      this.tempOptions[0].defaultTheme = true
    },
    getCode () {
      console.log('dsadsadasd')
      if (!this.form.name) {
        this.$message.warning('请先填写用户名')
        return false
      }
      if (!this.form.companyName) {
        this.$message.warning('请先填写公司名称')
        return false
      }
      if (!this.form.account) {
        this.$message.warning('请填写正确的手机号')
        return false
      }
      this.api.system.getSMSCode({ account: this.form.account }).then((result) => {
        console.log('dsadsadasd')
        if (result.success) {
          this.$message({
            message: "短信已发送",
            type: "success",
          });
          this.timeInterval();
        }
      }).catch((error) => {
        console.log(error);
      });
    },
    //倒计时
    timeInterval () {
      console.log('timeInterval')
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.codeBtnShow = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.codeBtnShow = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    switchStep (index) {
      this.stepIndex = index
    },
    sucessNext () {
      // this.stepIndex = 2
      // console.log('asdsadsad')
      this.api.agentUserInfo.copySchoolPage().then(res => {
        if (res.code == 200) this.stepIndex = 2;
        else this.$message.error(res.message);
      })
    },
    toPreviewH5 () {
      !this.registerData.id ? '生成失败' : window.open(`http://${this.registerData.id}.h5.68wx.com`)
      // window.location.href = `${this.registerData.operatorId || '1378606848921190400'}h5.68wx.com`
    },
    login () {
      var params = {
        name: this.form.companyName,
        mobile: this.form.account,
        userName: this.form.name,
        code: this.form.code
      }
      this.api.agentUserInfo.addAgentInfoListByAccount(params).then((result) => {
        if (result.success) {
          this.$message.success('操作成功');
          // this.$router.push("/");
          this.registerData = result.data
          localStorage.setItem("registerObj", JSON.stringify(result.data) || {})
          this.switchStep(1)
        } else {
          this.$message.error(result.message);
        }
      });
    },
    changeItemIndex (index) {
      console.log(index)
      this.clickedTemp = index
    },
    getTempDictionary (callback) {
      this.api.dictionary.getTempDictionaryData().then(result => {
        console.log(result)
        this.tempOptions = result.data
        this.choosedTemplate = result.data[0] ? result.data[0].id : ''
        this.tempOptions.forEach((v, k) => {
          if (v.defaultTheme) {
            this.disableNextFlag = false
          }
        })
        callback && callback()
      }).catch(error => {
        console.log(error);
      });
    },

  }
}
</script>
<style lang="less" scoped>
.h5Container {
  width: 7.5rem;
  background: #fff;
  // height: 100vh;
  .defaultInput {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    -o-appearance: none;
    border: none;
    box-shadow: none;
    outline: none;
  }
  .stepBar {
    display: flex;
    flex-direction: row;
    position: relative;
    width: 7.5rem;
    overflow: hidden;
    .stepSlider {
      background: #006aff;
      width: 2rem;
      position: absolute;
      top: 0;
      height: 0.48rem;
    }
    .stepItem {
      position: relative;
      z-index: 10;
      width: 2.5rem;
      height: 0.48rem;
      line-height: 0.48rem;
      text-align: center;
      font-size: 0.28rem;
      color: #97979f;
      background: #fff;
    }
    .stepItemReact {
      background: #006aff;
      color: #ffffff;
      border-radius: 0;
    }
    .rightArrow {
      border-top-right-radius: 0.24rem;
      border-bottom-right-radius: 0.24rem;
    }
    .stepActive {
      background: #006aff;
      color: #ffffff;
    }
  }
  .banner {
    width: 7.5rem;
    height: 3.6rem;
    margin-bottom: 0.3rem;
  }
  .inputBox {
    padding: 0 0.6rem;
    .inputItem {
      margin-top: 0.7rem;
      padding-bottom: 0.22rem;
      border-bottom: 0.01rem solid #e7eef2;
      position: relative;
      .getVerifyCode {
        font-size: 0.24rem;
        color: #006aff;
        padding: 0.12rem;
        border: 1px solid #006aff;
        display: inline-block;
        position: absolute;
        right: 0;
        bottom: 0.13rem;
        border-radius: 0.12rem;
      }
      input {
        font-size: 0.28rem;
        width: 100%;
      }
    }
  }
  .nextStep {
    height: 0.88rem;
    width: 7.5rem;
    text-align: center;
    background: #006aff;
    color: #fff;
    line-height: 0.88rem;
    position: absolute;
    bottom: 0;
    left: 0;
  }
  .disabledBtn {
    background: #e7eef2 !important;
    color: #97979f !important;
  }
  .themeBox {
    padding: 0 0.4rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
    padding-bottom: 1rem;
    position: relative;
    .themeItem {
      display: flex;
      flex-shrink: 0;
      width: 3.15rem;
      flex-direction: column;
      margin-top: 0.41rem;
      position: relative;
      .cover {
        position: absolute;
        bottom: 0rem;
        left: 0;
        width: 3.15rem;
        height: 5.6rem;
        background: #1b88d6;
        opacity: 0.4;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 0.61rem;
          height: 0.61rem;
        }
      }
      p {
        color: #262626;
        font-size: 0.28rem;
        margin-bottom: 0.13rem;
      }
      img {
        width: 3.15rem;
        height: 5.6rem;
      }
    }
    .nextStep {
      height: 0.88rem;
      width: 7.5rem;
      text-align: center;
      background: #006aff;
      color: #fff;
      line-height: 0.88rem;
      position: fixed;
      bottom: 0;
      left: 0;
    }
  }
  .successBox {
    position: relative;
    width: 7.5rem;
    height: 95vh;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 3.54rem;
    img {
      width: 1.2rem;
      height: 1.2rem;
      margin-bottom: 0.31rem;
    }
    p {
      font-size: 0.32rem;
      color: #262626;
    }
    .nextStep {
      height: 0.88rem;
      width: 7.5rem;
      text-align: center;
      background: #006aff;
      color: #fff;
      line-height: 0.88rem;
      position: fixed;
      bottom: 0;
      left: 0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/h5/register.vue